import { render, staticRenderFns } from "./Chessboard.vue?vue&type=template&id=ad7ed64e&scoped=true&"
import script from "./Chessboard.vue?vue&type=script&lang=js&"
export * from "./Chessboard.vue?vue&type=script&lang=js&"
import style0 from "./Chessboard.vue?vue&type=style&index=0&id=ad7ed64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7ed64e",
  null
  
)

export default component.exports